<template>
  <div>
    <div class="container-fluid featured-page-image">
      <div class="feature-header-page">
        <h1>Gallery</h1>
      </div>
    </div>
    <div class="container">
      <div class="intro">
        <h2>Gallery</h2>
        <hr>
        <div class="row">
          <div v-for="i in 14" :key="'gallery-image-' + i" class="col-md-6 col-lg-4">
            <img v-img:group
                 :src="require(`@/assets/images/gallery/${i}.jpg`)"
                 alt="Gallery Image"
                 class="gallery-image">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Gallery'
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Gallery.vue